export default __webpack_public_path__ + "static/media/radi_becker.41c88e69.png";